import React from 'react';
import PropTypes from 'prop-types';
import { getCart } from 'utils/Cookies';
import { getCartDomain } from 'utils/Window';
import SiteNavADesktop from 'components/SiteNav/SiteNavA/SiteNavADesktop';
import SiteNavAMobile from 'components/SiteNav/SiteNavA/SiteNavAMobile';

const SiteNavA = (props) => {
  const {
    items = [],
    contactHrefDesktop,
    contactTargetDesktop,
    contactHrefMobile,
    host,
  } = props;

  // Get the cart cookie "itemsCount" property from the "bag" object
  const cartCookie = getCart(host);
  const { bag = {} } = cartCookie;
  const { itemsCount = 0 } = bag;

  // Get Cart Url based on environment
  const cartUrl = `//${getCartDomain(host)}/cart`;

  return (
    <nav>
      {items.length > 0 && ([
        <SiteNavADesktop
          key='desktop'
          {...props}
          itemsCount={itemsCount}
          cartUrl={cartUrl}
          contactHref={contactHrefDesktop}
          contactTarget={contactTargetDesktop}
        />,
        <SiteNavAMobile
          key='mobile'
          {...props}
          itemsCount={itemsCount}
          cartUrl={cartUrl}
          contactHref={contactHrefMobile}
        />,
      ])}
    </nav>
  );
};

SiteNavA.propTypes = {
  /**
  * SiteNavA Items
  */
  items: PropTypes.array.isRequired,
  /**
  * Contact info Href for Desktop
  */
  contactHrefDesktop: PropTypes.string,
  /**
  * Contact info Target for Desktop
  */
  contactTargetDesktop: PropTypes.string,
  /**
  * Contact info Href for Mobile
  */
  contactHrefMobile: PropTypes.string,
  /**
  * Site Domain
  */
  host: PropTypes.string,
};

export default SiteNavA;
